'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { GridLayout, GridTemplateAreas } from '@styles/GridVariables';
import { Spacers } from '@styles/theme';

export const Action = styled.p`
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
`;

export const MenuModalContainer = styled.dialog`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${Spacers.BASE}rem;
  gap: ${Spacers.XS}rem;
  border-radius: none;
  border: none;
  border-bottom: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  position: fixed;
  top: ${(props) => props.theme.dimensions.headerHeight};
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  grid-area: content;

  ${breakpoints.desktopOrBigger} {
    position: relative;
    border-radius: ${Spacers.XS}rem;
    border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
    grid-area: content;
    grid-column: 5 / -2;
    margin-top: ${Spacers.XS}rem;
    top: 0;
  }
`;

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacers.XS}rem;
`;

export const MenuOptionContainer = styled.button`
  border: none;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  padding: ${Spacers.XS}rem;
  border-radius: ${Spacers.XS}rem;
  color: ${(props) => props.theme.colors.typographyHeadersLight};

  &:hover {
    ${Action} {
      color: ${(props) => props.theme.colors.actionDefault};
    }
    & svg {
      color: ${(props) => props.theme.colors.actionDefault};
    }
    background-color: ${({ theme }) => theme.colors.actionInactive};
  }

  &:active {
    ${Action} {
      color: ${(props) => props.theme.colors.actionActive};
    }
    & svg {
      color: ${(props) => props.theme.colors.actionActive};
    }
    background-color: ${({ theme }) => theme.colors.actionInactive};
  }
`;

export const BackdropMenu = styled.div<{ $isAdmin?: boolean }>`
  position: fixed;
  inset: 0;
  top: ${(props) => props.theme.dimensions.headerHeight};
  background-color: ${({ theme }) => theme.colors.backgroundDarkOverlay};
  display: grid;
  z-index: 100;

  // The container is fixed that's why we have to reuse grid for bottom layout.
  ${breakpoints.desktopOrBigger} {
    grid-template-columns: ${(props) => (props.$isAdmin ? 'none' : GridLayout.desktop.columns)};
    gap: ${GridLayout.desktop.gap};
    grid-template-areas: ${GridTemplateAreas.desktop};
    padding: 0;
    justify-content: flex-end;
  }
`;
